import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import LocationsPage from '@/views/LocationsPage.vue'
import StatePage from '@/views/State.vue'
import Control from '@/views/Control.vue'
import Login from '@/views//Login.vue'
// import Locations from '@/views/Locations.vue'  // 删除或注释掉

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    redirect: '/locations',
    children: [
      {
        path: 'locations',
        name: 'LocationsPage',
        component: LocationsPage
      },
      {
        path: 'state/:sensorId',
        name: 'StatePage',
        component: StatePage
      },
      {
        path: 'control',
        name: 'Control',
        component: Control
      },
      {
        path: 'parts',
        name: 'PartsPage',
        component: () => import('@/views/Parts.vue')
      },
      {
        path: 'maintenance',
        name: 'MaintenancePage',
        component: () => import('@/views/Maintenance.vue')
      },
      {
        path: 'admin-brand',
        name: 'AdminBrand',
        component: () => import('@/views/AdminBrand.vue')
      },
      {
        path: 'door-analytics',
        name: 'DoorAnalytics',
        component: () => import('@/views/DoorAnalytics.vue')
      },
      {
        path: 'history-data',
        name: 'DeviceHistory',
        component: () => import('@/views/DeviceHistory.vue')
      },
      {
        path: 'sensor-card/:locationId',
        name: 'SensorCardPage',
        component: () => import('@/views/SensorCard.vue')
      }
    ]
  },
  { path: '/login', component: Login },
  { path: '/locations', component: LocationsPage },
  { path: '/:pathMatch(.*)*', redirect: '/login' }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true'
  const userType = localStorage.getItem('userType')
  const locationId = localStorage.getItem('locationId')
  
  if (to.path !== '/login' && !isAuthenticated) {
    next('/login')
  } else if (to.path === '/login' && isAuthenticated) {
    // 已登录用户访问登录页，根据用户类型重定向
    if (userType === 'location' && locationId) {
      next(`/state/${locationId}`)
    } else {
      next('/locations')
    }
  } else if (isAuthenticated && userType === 'location') {
    if (to.name === 'StatePage' && to.params.sensorId !== locationId) {
      next(`/state/${locationId}`)
    } else if (to.name === 'SensorCardPage' && to.params.locationId !== locationId) {
      next(`/sensor-card/${locationId}`)
    } else if (to.name === 'LocationsPage') {
      next(`/state/${locationId}`)
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router 